const ChatGPT = () => import('@/components/account/ChatGPT.vue')

const chatPermissions = [
  'conversacion'
]

export const chatgptRoutes = [
  {path: '/chat-gpt', component: ChatGPT, meta: { breadcrumb: 'Chat GPT', requiresAuth: true, permissions: chatPermissions } },
]
